import { Icon } from '@/features/common';
import styled from '@emotion/styled';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { DSButton } from '@hundred5/design-system';
import React from 'react';
import { usePreferenceMutation } from '../../queries';

export function TermsOfServiceBanner() {
  const preferenceMutation = usePreferenceMutation();

  const handleClose = () => {
    preferenceMutation.mutate({
      name: 'closedTermsOfService01072025Banner',
      value: true,
    });
  };

  return (
    <Container>
      <Content>
        <span>
          We’re updating our{' '}
          <a
            href="https://toggl.com/legal/hire/terms/v4.0/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>{' '}
          on 1st July 2025. By continuing to use Toggl Hire, you agree to these
          updates.
        </span>
        <DSButton
          variant="tertiary"
          size="xsmall"
          onClick={() => {
            window.open(
              'https://support.hire.toggl.com/en/articles/11172609-updates-to-terms-of-service-june-2025',
              '_blank'
            );
          }}
        >
          Learn more
        </DSButton>
      </Content>

      <CloseButton onClick={handleClose}>
        <Icon icon={regular('xmark')} color="purple-60" />
      </CloseButton>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  height: 36px;
  padding: 6px 24px;
  align-items: center;
  gap: 10px;
  background: ${({ theme }) => theme.colors.orange[20]};
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1;

  span {
    color: ${({ theme }) => theme.typography.colorPrimary};
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    a {
      color: inherit;
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;

const CloseButton = styled.button`
  -webkit-appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
`;
